/* tslint:disable */
/* eslint-disable */
/**
 * Risk Management System API
 * Risk Management System API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import {
    ApiUserEvent,
    ApiUserEventFromJSON,
    ApiUserEventToJSON,
} from '../models';

export interface AddUserEventRequest {
    apiUserEvent: ApiUserEvent;
}

/**
 * 
 */
export class UserEventApi extends runtime.BaseAPI {

    /**
     * Creates new user event
     */
    async addUserEventRaw(requestParameters: AddUserEventRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.apiUserEvent === null || requestParameters.apiUserEvent === undefined) {
            throw new runtime.RequiredError('apiUserEvent','Required parameter requestParameters.apiUserEvent was null or undefined when calling addUserEvent.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", ["read", "write"]);
        }

        const response = await this.request({
            path: `/v1/user-events`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ApiUserEventToJSON(requestParameters.apiUserEvent),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Creates new user event
     */
    async addUserEvent(requestParameters: AddUserEventRequest, initOverrides?: RequestInit): Promise<void> {
        await this.addUserEventRaw(requestParameters, initOverrides);
    }

}
